import { BaseApi } from "../BaseApi";
import { InterceptToken } from "../../interceptors/TokenInterceptor";

const consultarAseguradoUrl = (request) =>
  `api/v1/websalud/primeraars/asegurado/${request.numeroPlastico}`;

const consultarAseguradoIsCronicoComplejoUrl = (request) =>
  `api/v1/websalud/primeraars/asegurado/${request.numeroPlastico}/cronicos-complejos`;


const consultarAsegurado = (request) =>
  InterceptToken(
    BaseApi.get,
    consultarAseguradoUrl(request.requestData),
    null,
    request.requestHeaders
  ).then((response) => response.data);

  const consultarAseguradoIsCronicoComplejo = (request) =>
    InterceptToken(
      BaseApi.get,
      consultarAseguradoIsCronicoComplejoUrl(request.requestData),
      null,
      request.requestHeaders
    ).then((response) => response.data);

const exportedObject = {
  consultarAsegurado,
  consultarAseguradoIsCronicoComplejo
};

export default exportedObject;